import { useQuery } from "react-query";
import { getEmployeeTerminationReason } from "../../../../../actions/Employees";

export const useEmployeeTerminationReason = () => {
  return useQuery(
    "GetEmployeeTerminationReason",
    getEmployeeTerminationReason,
    {
      refetchOnWindowFocus: false,
    }
  );
};
